export default __webpack_public_path__ + "static/media/pad.90a18d79.svg";